import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('div', {
    staticClass: "login-img"
  }), _c('div', {
    staticClass: "lodin-content"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": _vm.epImg || "/static/toc/mobile/img/logo_danxiaoer_1.png"
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.user.epName || ''))]), _c('div', {
    staticClass: "title"
  }, [_vm._v(i18n.tc("182"))])]), _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-tab"
  }, [_c('div', {
    class: ['tab-text', {
      'login-tab-active': _vm.type === 2
    }],
    on: {
      "click": function ($event) {
        _vm.type = 2;
      }
    }
  }, [_vm._v(i18n.tc("189"))]), _c('div', {
    class: ['tab-text', {
      'login-tab-active': _vm.type === 1
    }],
    on: {
      "click": function ($event) {
        _vm.type = 1;
      }
    }
  }, [_vm._v(i18n.tc("190"))])]), _c('div', {
    staticClass: "login-input-box"
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/toc/mobile/img/denglu-02.png"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }],
    staticClass: "input-class font-size-h3-large",
    attrs: {
      "type": "text",
      "placeholder": i18n.tc("191")
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.phone = $event.target.value;
      }
    }
  })]), _vm.type === 1 ? [_c('div', {
    staticClass: "login-input-box"
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/toc/mobile/img/denglu-03.png"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "input-class font-size-h3-large",
    attrs: {
      "type": "password",
      "placeholder": i18n.tc("192")
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.password = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "erro-tip"
  }, [_c('div', {
    staticClass: "remember-password",
    on: {
      "click": function ($event) {
        _vm.remember = !_vm.remember;
      }
    }
  }, [_c('div', {
    staticClass: "checkbox-img"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.remember,
      expression: "remember"
    }],
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/checksquare32_32@3x.png"
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.remember,
      expression: "!remember"
    }],
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/nochecksquare32_32@3x.png"
    }
  })]), _vm._v(" \xA0\xA0" + i18n.tc("193") + " ")]), _c('router-link', {
    staticStyle: {
      "color": "#169bd5"
    },
    attrs: {
      "to": {
        name: 'Register',
        query: {
          type: 2
        }
      }
    }
  }, [_vm._v(i18n.tc("194"))])], 1)] : _vm._e(), _vm.type === 2 ? [_c('div', {
    staticClass: "login-input-box"
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/toc/mobile/img/denglu-04.png"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verify_code,
      expression: "verify_code"
    }],
    staticClass: "input-class verify-input font-size-h3-large",
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": i18n.tc("177")
    },
    domProps: {
      "value": _vm.verify_code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.verify_code = $event.target.value;
      }
    }
  }), _c('x-button', {
    staticClass: "get-verify-btn",
    attrs: {
      "mini": "",
      "disabled": _vm.wait <= 60
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.getVerify.apply(null, arguments);
      }
    }
  }, [_c('font', {
    staticClass: "get-verify-text"
  }, [_vm._v(i18n.tc("186") + _vm._s(_vm.wait < 60 && _vm.wait > 0 ? "(" + _vm.wait + ")" : ''))])], 1)], 1)] : _vm._e(), _c('x-button', {
    staticClass: "login-btn",
    attrs: {
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.login.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("6"))]), _c('router-link', {
    staticStyle: {
      "color": "#169bd5"
    },
    attrs: {
      "to": {
        name: 'Register',
        query: {
          type: 1
        }
      }
    }
  }, [_vm._v(" " + i18n.tc("195") + " ")])], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };